import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormError from "../../../shared/components/FormError";
import { loadHourlySalaryUpdateDataRequest } from "../redux/Actions";
import HourlySalaryForm from "./HourlySalaryForm";

const HourlySalaryEdit = ({ handleClose, hourlySalary }) => {
  const dispatch = useDispatch();
  let [shouldCloseModal, setShouldCloseModal] = useState(false);
  let [errorMessage, setErrorMessage] = useState(false);

  let { loading, error } = useSelector((state) => state.hourlySalary);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        handleClose(true);
      } else {
        setErrorMessage(error.msg);
      }
      setShouldCloseModal(false);
    }
  }, [loading, error, shouldCloseModal]);

  function submit(values) {
    dispatch(loadHourlySalaryUpdateDataRequest(values));
    setShouldCloseModal(true);
  }
  function cancel() {
    handleClose(false);
  }
  return (
    <>
      <FormError>
        {errorMessage}
      </FormError>
      <HourlySalaryForm
        submit={submit}
        cancel={cancel}
        hourlySalary={hourlySalary}
      />
      ;
    </>
  );
};

export default HourlySalaryEdit;
